import { LRParser } from '@lezer/lr';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf$1 = 167,
  nan$1 = 168,
  Bool$1 = 1,
  Ignoring$1 = 2,
  On$1 = 3,
  GroupLeft$1 = 4,
  GroupRight$1 = 5,
  Offset$1 = 6,
  Atan2$1 = 7,
  Avg$1 = 8,
  Bottomk$1 = 9,
  Count$1 = 10,
  CountValues$1 = 11,
  Group$1 = 12,
  Max$1 = 13,
  Min$1 = 14,
  Quantile$1 = 15,
  LimitK$1 = 16,
  LimitRatio$1 = 17,
  Stddev$1 = 18,
  Stdvar$1 = 19,
  Sum$1 = 20,
  Topk$1 = 21,
  By$1 = 22,
  Without$1 = 23,
  And$1 = 24,
  Or$1 = 25,
  Unless$1 = 26,
  Start$1 = 27,
  End$1 = 28,
  Smoothed$1 = 29,
  Anchored$1 = 30;

// Copyright 2021 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


const keywordTokens = {
    inf: inf$1,
    nan: nan$1,
    bool: Bool$1,
    ignoring: Ignoring$1,
    on: On$1,
    group_left: GroupLeft$1,
    group_right: GroupRight$1,
    offset: Offset$1,
};

const specializeIdentifier = (value, stack) => {
    return keywordTokens[value.toLowerCase()] || -1;
};

const contextualKeywordTokens = {
    avg: Avg$1,
    atan2: Atan2$1,
    bottomk: Bottomk$1,
    count: Count$1,
    count_values: CountValues$1,
    group: Group$1,
    max: Max$1,
    min: Min$1,
    quantile: Quantile$1,
    limitk: LimitK$1,
    limit_ratio: LimitRatio$1,
    stddev: Stddev$1,
    stdvar: Stdvar$1,
    sum: Sum$1,
    topk: Topk$1,
    by: By$1,
    without: Without$1,
    and: And$1,
    or: Or$1,
    unless: Unless$1,
    start: Start$1,
    end: End$1,
    smoothed: Smoothed$1,
    anchored: Anchored$1,
};

const extendIdentifier = (value, stack) => {
    return contextualKeywordTokens[value.toLowerCase()] || -1;
};

// Copyright 2022 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


const promQLHighLight = styleTags({
    LineComment: tags.comment,
    LabelName: tags.labelName,
    StringLiteral: tags.string,
    NumberDurationLiteral: tags.number,
    NumberDurationLiteralInDurationContext: tags.number,
    Identifier: tags.variableName,
    'Abs Absent AbsentOverTime Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp Floor HistogramAvg HistogramCount HistogramFraction HistogramQuantile HistogramSum DoubleExponentialSmoothing Hour Idelta Increase Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MaxOverTime MinOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc SortByLabel SortByLabelDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Time Timestamp Vector Year':
        tags.function(tags.variableName),
    'Avg Bottomk Count Count_values Group LimitK LimitRatio Max Min Quantile Stddev Stdvar Sum Topk': tags.operatorKeyword,
    'By Without Bool On Ignoring GroupLeft GroupRight Offset Start End Smoothed Anchored': tags.modifier,
    'And Unless Or': tags.logicOperator,
    'Sub Add Mul Mod Div Atan2 Eql Neq Lte Lss Gte Gtr EqlRegex EqlSingle NeqRegex Pow At': tags.operator,
    UnaryOp: tags.arithmeticOperator,
    '( )': tags.paren,
    '[ ]': tags.squareBracket,
    '{ }': tags.brace,
    '⚠': tags.invalid,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_Identifier = {__proto__:null,absent_over_time:353, absent:355, abs:357, acos:359, acosh:361, asin:363, asinh:365, atan:367, atanh:369, avg_over_time:371, ceil:373, changes:375, clamp:377, clamp_max:379, clamp_min:381, cos:383, cosh:385, count_over_time:387, days_in_month:389, day_of_month:391, day_of_week:393, day_of_year:395, deg:397, delta:399, deriv:401, exp:403, first_over_time:405, floor:407, histogram_count:409, histogram_fraction:411, histogram_quantile:413, histogram_stddev:415, histogram_stdvar:417, histogram_sum:419, histogram_avg:421, double_exponential_smoothing:423, hour:425, idelta:427, increase:429, info:431, irate:433, label_replace:435, label_join:437, last_over_time:439, ln:441, log10:443, log2:445, mad_over_time:447, max_over_time:449, min_over_time:451, ts_of_first_over_time:453, ts_of_max_over_time:455, ts_of_min_over_time:457, ts_of_last_over_time:459, minute:461, month:463, pi:465, predict_linear:467, present_over_time:469, quantile_over_time:471, rad:473, rate:475, resets:477, round:479, scalar:481, sgn:483, sin:485, sinh:487, sort:489, sort_desc:491, sort_by_label:493, sort_by_label_desc:495, sqrt:497, stddev_over_time:499, stdvar_over_time:501, sum_over_time:503, tan:505, tanh:507, timestamp:509, time:511, vector:513, year:515};
const parser = LRParser.deserialize({
  version: 14,
  states: ":^OYQPOOO(TQPOOOOQO'#DO'#DOO(YQPO'#C}Q(eQQOOOOQO'#Dg'#DgO(`QPO'#DfOOQO'#Fa'#FaO)xQPO'#FhOYQPO'#FeOYQPO'#FgO0|QSO'#FjO1XQQO'#FiOOQO'#Fi'#FiOOQO'#F}'#F}OOQO'#Dh'#DhOOQO'#Dj'#DjOOQO'#Dk'#DkOOQO'#Dl'#DlOOQO'#Dm'#DmOOQO'#Dn'#DnOOQO'#Do'#DoOOQO'#Dp'#DpOOQO'#Dq'#DqOOQO'#Dr'#DrOOQO'#Ds'#DsOOQO'#Dt'#DtOOQO'#Du'#DuOOQO'#Dv'#DvOOQO'#Dw'#DwOOQO'#Dx'#DxOOQO'#Dy'#DyOOQO'#Dz'#DzOOQO'#D{'#D{OOQO'#D|'#D|OOQO'#D}'#D}OOQO'#EO'#EOOOQO'#EP'#EPOOQO'#EQ'#EQOOQO'#ER'#EROOQO'#ES'#ESOOQO'#ET'#ETOOQO'#EU'#EUOOQO'#EV'#EVOOQO'#EW'#EWOOQO'#EX'#EXOOQO'#EY'#EYOOQO'#EZ'#EZOOQO'#E['#E[OOQO'#E]'#E]OOQO'#E^'#E^OOQO'#E_'#E_OOQO'#E`'#E`OOQO'#Ea'#EaOOQO'#Eb'#EbOOQO'#Ec'#EcOOQO'#Ed'#EdOOQO'#Ee'#EeOOQO'#Ef'#EfOOQO'#Eg'#EgOOQO'#Eh'#EhOOQO'#Ei'#EiOOQO'#Ej'#EjOOQO'#Ek'#EkOOQO'#El'#ElOOQO'#Em'#EmOOQO'#En'#EnOOQO'#Eo'#EoOOQO'#Ep'#EpOOQO'#Eq'#EqOOQO'#Er'#ErOOQO'#Es'#EsOOQO'#Et'#EtOOQO'#Eu'#EuOOQO'#Ev'#EvOOQO'#Ew'#EwOOQO'#Ex'#ExOOQO'#Ey'#EyOOQO'#Ez'#EzOOQO'#E{'#E{OOQO'#E|'#E|OOQO'#E}'#E}OOQO'#FO'#FOOOQO'#FP'#FPOOQO'#FQ'#FQOOQO'#FR'#FROOQO'#FS'#FSOOQO'#FT'#FTOOQO'#FU'#FUOOQO'#FV'#FVOOQO'#FW'#FWOOQO'#FX'#FXOOQO'#FY'#FYOOQO'#FZ'#FZOOQO'#F['#F[OOQO'#F]'#F]OOQO'#F^'#F^QOQPOOO2xQPO'#DPO2}QPO'#DUO(`QPO,59iO3UQQO,59iO4xQPO,59qO4xQPO,59qO4xQPO,59qO4xQPO,59qO4xQPO,59qO;|QPO,5;yO;|QPO,5;|OOQO,5;},5;}OOQO,5<O,5<OO<_QPO,5<]OOQO,5:Q,5:QOOQO,5;{,5;{O<vQQO,5<PO<}QQO,5<ROOQO'#DS'#DSO>kQPO'#FkO>yQPO,5<UOOQO,5<U,5<UO?VQPO,5<UOOQO,5<T,5<TO?_QSO'#DQOOQO,59k,59kOOQO,59p,59pO?jQQO,59pOOQO1G/T1G/TOOQO'#DX'#DXO2xQPO'#DYOOQO'#GR'#GRO?tQPO'#GROYQPO1G/]OYQPO1G/]OYQPO1G/]OYQPO1G/]OYQPO1G/]OOQO'#F`'#F`OFuQPO'#F`OGQQSO1G1eOOQO1G1h1G1hOGYQPO'#FaOOQO'#Fs'#FsOOQO1G1w1G1wOGeQPO1G1wOOQO1G1k1G1kOOQO'#Fl'#FlOGjQPO,5<VOGoQPO,5<[OGtQSO1G1pOHPQPO1G1pOOQO1G1p1G1pOOQO,59l,59lOHXQPO,59lOYQPO'#FvOHaQPO1G/[OOQO1G/[1G/[OHiQPO,59tOOQO,5<m,5<mO!!zQQO7+$wO!#[QQO7+$wO!$vQQO7+$wO!%^QQO7+$wO!&uQQO7+$wOOQO,5;z,5;zOOQO7+'P7+'PO!'fQPO7+'WO!'mQPO7+'cOOQO1G1q1G1qOOQO1G1v1G1vO!'rQPO,5<cOOQO,5<c,5<cOOQO7+'[7+'[O!(WQSO7+'[OOQO-E9u-E9uO!(cQSO1G/WO!(nQPO1G/WOOQO1G/W1G/WO!(vQQO,5<bOOQO-E9t-E9tOOQO7+$v7+$vO!)QQPO1G/`OOQO<<Jr<<JrO!/{QPO<<JrOOQO<<J}<<J}OOQO<<Jv<<JvP!0QQSO'#FwOOQO,5<a,5<aOOQO7+$r7+$rO!0YQSO7+$rOOQO-E9s-E9sOOQO7+$z7+$zOOQOAN@^AN@^OOQO<<H^<<H^P!0eQSO'#Fu",
  stateData: "!0m~O$pOSoOS~OWQOXQOYQOZQO[QO]QO^QO_QO`QOaQObQOcQOdQOeQOw^O!][O$mVO$nVO$rXO$v_O$w`O$xaO$ybO$zcO${dO$|eO$}fO%OgO%PhO%QiO%RjO%SkO%TlO%UmO%VnO%WoO%XpO%YqO%ZrO%[sO%]tO%^uO%_vO%`wO%axO%byO%czO%d{O%e|O%f}O%g!OO%h!PO%i!QO%j!RO%k!SO%l!TO%m!UO%n!VO%o!WO%p!XO%q!YO%r!ZO%s![O%t!]O%u!^O%v!_O%w!`O%x!aO%y!bO%z!cO%{!dO%|!eO%}!fO&O!gO&P!hO&Q!iO&R!jO&S!kO&T!lO&U!mO&V!nO&W!oO&X!pO&Y!qO&Z!rO&[!sO&]!tO&^!uO&_!vO&`!wO&a!xO&b!yO&c!zO&d!{O&e!|O&f!}O&g#OO&h#PO&i#QO&j#RO&k#SO&mWO&nWO&oVO&rZO~O!]#TO~Of#UOg#UO$r#VO~OU#`OV#YOh#]Oi#^Oj#]Om#bOn#aOz#YO}#YO!O#YO!P#YO!Q#ZO!R#ZO!S#[O!T#[O!U#[O!V#[O!W#[O!X#[O$f#cO&l#_O~O$m#eO$n#eO&o#eOW$[XX$[XY$[XZ$[X[$[X]$[X^$[X_$[X`$[Xa$[Xb$[Xc$[Xd$[Xe$[Xw$[X!]$[X$m$[X$n$[X$r$[X$v$[X$w$[X$x$[X$y$[X$z$[X${$[X$|$[X$}$[X%O$[X%P$[X%Q$[X%R$[X%S$[X%T$[X%U$[X%V$[X%W$[X%X$[X%Y$[X%Z$[X%[$[X%]$[X%^$[X%_$[X%`$[X%a$[X%b$[X%c$[X%d$[X%e$[X%f$[X%g$[X%h$[X%i$[X%j$[X%k$[X%l$[X%m$[X%n$[X%o$[X%p$[X%q$[X%r$[X%s$[X%t$[X%u$[X%v$[X%w$[X%x$[X%y$[X%z$[X%{$[X%|$[X%}$[X&O$[X&P$[X&Q$[X&R$[X&S$[X&T$[X&U$[X&V$[X&W$[X&X$[X&Y$[X&Z$[X&[$[X&]$[X&^$[X&_$[X&`$[X&a$[X&b$[X&c$[X&d$[X&e$[X&f$[X&g$[X&h$[X&i$[X&j$[X&k$[X&m$[X&n$[X&o$[X&r$[X~Ou#iOw#hO&s#kO~O&rZOU$]XV$]Xh$]Xi$]Xj$]Xm$]Xn$]Xz$]X}$]X!O$]X!P$]X!Q$]X!R$]X!S$]X!T$]X!U$]X!V$]X!W$]X!X$]X$f$]X$l$]X&l$]X$t$]X$s$]X~O$r#nO~O$t#pO~PYOf#UOg#UOUqaVqahqaiqajqamqanqazqa}qa!Oqa!Pqa!Qqa!Rqa!Sqa!Tqa!Uqa!Vqa!Wqa!Xqa$fqa$lqa&lqa$tqa$sqa~OP#sOQ#tOR#tOW$uPX$uPY$uPZ$uP[$uP]$uP^$uP_$uP`$uPa$uPb$uPc$uPd$uPe$uPw$uP!]$uP$m$uP$n$uP$r$uP$v$uP$w$uP$x$uP$y$uP$z$uP${$uP$|$uP$}$uP%O$uP%P$uP%Q$uP%R$uP%S$uP%T$uP%U$uP%V$uP%W$uP%X$uP%Y$uP%Z$uP%[$uP%]$uP%^$uP%_$uP%`$uP%a$uP%b$uP%c$uP%d$uP%e$uP%f$uP%g$uP%h$uP%i$uP%j$uP%k$uP%l$uP%m$uP%n$uP%o$uP%p$uP%q$uP%r$uP%s$uP%t$uP%u$uP%v$uP%w$uP%x$uP%y$uP%z$uP%{$uP%|$uP%}$uP&O$uP&P$uP&Q$uP&R$uP&S$uP&T$uP&U$uP&V$uP&W$uP&X$uP&Y$uP&Z$uP&[$uP&]$uP&^$uP&_$uP&`$uP&a$uP&b$uP&c$uP&d$uP&e$uP&f$uP&g$uP&h$uP&i$uP&j$uP&k$uP&m$uP&n$uP&o$uP&r$uP~O$m#|O$n#|O&m#}O&n#}O&o#|O~Ok$ROl$RO$mVO$nVO&m$QO&n$QO&oVO~O$t$UO~P(eOz#YOU$ZaV$Zah$Zai$Zaj$Zam$Zan$Za}$Za!O$Za!P$Za!Q$Za!R$Za!S$Za!T$Za!U$Za!V$Za!W$Za!X$Za$f$Za$l$Za&l$Za$t$Za$s$Za~O!X$VO$a$VO$b$VO$c$VO~O!X$VO$a$VO$b$VO$c$VO$s$YO&s$[O~Ou$^Ow#hO$t$]O~O$s$_O$t$aO~P(eOQ#tOR#tOW$uXX$uXY$uXZ$uX[$uX]$uX^$uX_$uX`$uXa$uXb$uXc$uXd$uXe$uXw$uX!]$uX$m$uX$n$uX$r$uX$v$uX$w$uX$x$uX$y$uX$z$uX${$uX$|$uX$}$uX%O$uX%P$uX%Q$uX%R$uX%S$uX%T$uX%U$uX%V$uX%W$uX%X$uX%Y$uX%Z$uX%[$uX%]$uX%^$uX%_$uX%`$uX%a$uX%b$uX%c$uX%d$uX%e$uX%f$uX%g$uX%h$uX%i$uX%j$uX%k$uX%l$uX%m$uX%n$uX%o$uX%p$uX%q$uX%r$uX%s$uX%t$uX%u$uX%v$uX%w$uX%x$uX%y$uX%z$uX%{$uX%|$uX%}$uX&O$uX&P$uX&Q$uX&R$uX&S$uX&T$uX&U$uX&V$uX&W$uX&X$uX&Y$uX&Z$uX&[$uX&]$uX&^$uX&_$uX&`$uX&a$uX&b$uX&c$uX&d$uX&e$uX&f$uX&g$uX&h$uX&i$uX&j$uX&k$uX&m$uX&n$uX&o$uX&r$uX~O$m$iO$n$iO&o$iO~O&p$jO&q$kO~O$m#eO$n#eO&o#eO~O$r$lO~Ow$mO~Ow$nO~Ou#iOw#hO&s$qO~O$s$rO&s$qO~O$s$tO$t$vO~O$s$_O$t$yO~OS$zOT$zOW|aX|aY|aZ|a[|a]|a^|a_|a`|aa|ab|ac|ad|ae|aw|a!]|a$m|a$n|a$r|a$v|a$w|a$x|a$y|a$z|a${|a$||a$}|a%O|a%P|a%Q|a%R|a%S|a%T|a%U|a%V|a%W|a%X|a%Y|a%Z|a%[|a%]|a%^|a%_|a%`|a%a|a%b|a%c|a%d|a%e|a%f|a%g|a%h|a%i|a%j|a%k|a%l|a%m|a%n|a%o|a%p|a%q|a%r|a%s|a%t|a%u|a%v|a%w|a%x|a%y|a%z|a%{|a%||a%}|a&O|a&P|a&Q|a&R|a&S|a&T|a&U|a&V|a&W|a&X|a&Y|a&Z|a&[|a&]|a&^|a&_|a&`|a&a|a&b|a&c|a&d|a&e|a&f|a&g|a&h|a&i|a&j|a&k|a&m|a&n|a&o|a&r|a~Oz#YOUyqhyqiyqjyqmyqnyq!Qyq!Ryq!Syq!Tyq!Uyq!Vyq!Wyq!Xyq$fyq$lyq&lyq$tyq$syq~OVyq}yq!Oyq!Pyq~P! jOV#YO}#YO!O#YO!P#YO~P! jOV#YOz#YO}#YO!O#YO!P#YO!Q#ZO!R#ZOUyqhyqiyqjyqmyqnyq$fyq$lyq&lyq$tyq$syq~O!Syq!Tyq!Uyq!Vyq!Wyq!Xyq~P!#lO!S#[O!T#[O!U#[O!V#[O!W#[O!X#[O~P!#lOV#YOh#]Oj#]Oz#YO}#YO!O#YO!P#YO!Q#ZO!R#ZO!S#[O!T#[O!U#[O!V#[O!W#[O!X#[O~OUyqiyqmyqnyq$fyq$lyq&lyq$tyq$syq~P!%tO&p${O~P;|O$t$}O~O!X$VO$a$VO$b$VO$c$VO$s$ka&s$ka~Ou#iOw#hO&s%OO~Ou%QOw#hO$t%RO~O$s%SO$t%RO~O$s$ja$t$ja~P(eO$r#nOW|iX|iY|iZ|i[|i]|i^|i_|i`|ia|ib|ic|id|ie|iw|i!]|i$m|i$n|i$v|i$w|i$x|i$y|i$z|i${|i$||i$}|i%O|i%P|i%Q|i%R|i%S|i%T|i%U|i%V|i%W|i%X|i%Y|i%Z|i%[|i%]|i%^|i%_|i%`|i%a|i%b|i%c|i%d|i%e|i%f|i%g|i%h|i%i|i%j|i%k|i%l|i%m|i%n|i%o|i%p|i%q|i%r|i%s|i%t|i%u|i%v|i%w|i%x|i%y|i%z|i%{|i%||i%}|i&O|i&P|i&Q|i&R|i&S|i&T|i&U|i&V|i&W|i&X|i&Y|i&Z|i&[|i&]|i&^|i&_|i&`|i&a|i&b|i&c|i&d|i&e|i&f|i&g|i&h|i&i|i&j|i&k|i&m|i&n|i&o|i&r|i~O&p%VO~Ou#iOw#hO~Ou%QOw#hO$t%WO~Ou%QOw#hO~O",
  goto: "*P$vPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP$w%T%a%gP%pP&Q$wP&Z&bPPPPPPPPPPP$w&l&xP&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x&x$w'U'_$w$w$w$w$w$w'n$w'z(Z(cPPP(Z$wP(jP(m(s(yPPPPP)QPPP)pe^OXY#V#w#x#y#z#{$_eROXY#V#w#x#y#z#{$_Q#WRR#r#XQ#o#UQ$b#tR%U$zQ#jZQ$^#nU$o$Y$r%PV%Q$t%S%XQ#XRQ#dUR#r#WZ#v#Y#Z#[#]#^Y#u#Y#Z#[#]#^R$c#veUOXY#V#w#x#y#z#{$_eTOXY#V#w#x#y#z#{$_Q$O#_Q$P#`R$|$kd^OXY#V#w#x#y#z#{$_R$S#ceYOXY#V#w#x#y#z#{$_d]OXY#V#w#x#y#z#{$_R#m[Q#lZV$p$Y$r%PQ$W#iT$X#j$oR$T#cQ$u$^R%T$uQ$`#qR$x$`S$Z#j#lR$s$ZQSOQ#fXQ#gYQ#q#VQ$d#wQ$e#xQ$f#yQ$g#zQ$h#{R$w$_Q#w#YQ#x#ZQ#y#[Q#z#]R#{#^",
  nodeNames: "⚠ Bool Ignoring On GroupLeft GroupRight Offset Atan2 Avg Bottomk Count CountValues Group Max Min Quantile LimitK LimitRatio Stddev Stdvar Sum Topk By Without And Or Unless Start End Smoothed Anchored LineComment PromQL AggregateExpr AggregateOp AggregateModifier GroupingLabels LabelName QuotedLabelName StringLiteral FunctionCallBody BinaryExpr Pow BoolModifier MatchingModifierClause Mul Div Mod Add Sub Eql Gte Gtr Lte Lss Neq FunctionCall FunctionIdentifier AbsentOverTime Identifier Absent Abs Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp FirstOverTime Floor HistogramCount HistogramFraction HistogramQuantile HistogramStdDev HistogramStdVar HistogramSum HistogramAvg DoubleExponentialSmoothing Hour Idelta Increase Info Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MadOverTime MaxOverTime MinOverTime TsOfFirstOverTime TsOfMaxOverTime TsOfMinOverTime TsOfLastOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc SortByLabel SortByLabelDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Timestamp Time Vector Year MatrixSelector NumberDurationLiteralInDurationContext NumberDurationLiteral OffsetExpr AnchoredExpr SmoothedExpr ParenExpr SubqueryExpr UnaryExpr UnaryOp VectorSelector LabelMatchers UnquotedLabelMatcher MatchOp EqlSingle EqlRegex NeqRegex QuotedLabelMatcher StepInvariantExpr At AtModifierPreprocessors MetricName",
  maxTerm: 265,
  nodeProps: [
    ["group", -14,33,39,41,56,141,143,144,145,146,147,148,149,151,159,"Expr"]
  ],
  propSources: [promQLHighLight],
  skippedNodes: [0,31],
  repeatNodeCount: 3,
  tokenData: "4k~RwX^#lpq#lqr$ars$tst&luv'Twx'Yxy({yz)Qz{)V{|)[|})c}!O)h!O!P)o!P!Q*u!Q!R*z!R![+u![!]1O!^!_1z!_!`2X!`!a2n!b!c2{!c!}3Q!}#O3h#P#Q3m#Q#R3r#R#S3Q#S#T3w#T#o3Q#o#p4a#q#r4f#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~#qY$p~X^#lpq#l#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~$dQ!_!`$j#r#s$o~$oO!X~~$tO$c~~$yWw~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f<%lO$t~%hOw~~%kRO;'S$t;'S;=`%t;=`O$t~%yXw~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f;=`<%l$t<%lO$t~&iP;=`<%l$t~&qSo~OY&lZ;'S&l;'S;=`&}<%lO&l~'QP;=`<%l&l~'YO!P~~'_Ww~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u<%lO'Y~'zRO;'S'Y;'S;=`(T;=`O'Y~(YXw~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u;=`<%l'Y<%lO'Y~(xP;=`<%l'Y~)QO$r~~)VO$t~~)[O}~R)cO&nP!QQ~)hO$s~R)oO&mP!RQ~)rP!Q![)u~)zS&o~!Q![)u!g!h*W#R#S)o#X#Y*W~*ZR{|*d}!O*d!Q![*j~*gP!Q![*j~*oQ&o~!Q![*j#R#S*d~*zO!O~~+P[&o~!O!P)o!Q![+u!g!h*W#R#S,m#W#X-X#X#Y*W#[#]-p#a#b.U#g#h.x#k#l/Z#l#m0d#m#n/u~+zZ&o~!O!P)o!Q![+u!g!h*W#R#S,m#W#X-X#X#Y*W#[#]-p#a#b.U#g#h.x#k#l/Z#m#n/u~,pP!Q![,s~,xT&o~!O!P)o!Q![,s!g!h*W#R#S,m#X#Y*W~-^P&o~!Q![-a~-dS!Q![-a#[#]-p#a#b.U#g#h.x~-uP&o~!Q![-x~-{R!Q![-x#a#b.U#g#h.x~.ZQ&o~!Q![.a#g#h.s~.dR!Q![.a#a#b.m#g#h.x~.pP#g#h.s~.xO&o~~.}P&o~!Q![/Q~/TQ!Q![/Q#a#b.m~/`P&o~!Q![/c~/fT!Q![/c#W#X-X#[#]-p#a#b.U#g#h.x~/zP&o~!Q![/}~0QU!Q![/}#W#X-X#[#]-p#a#b.U#g#h.x#k#l/Z~0gR!Q![0p!c!i0p#T#Z0p~0uR&o~!Q![0p!c!i0p#T#Z0pV1VT&qS!]R!Q![1f![!]1f!c!}1f#R#S1f#T#o1fR1kT!]R!Q![1f![!]1f!c!}1f#R#S1f#T#o1f~2PP!W~!_!`2S~2XO!V~~2^Q$aP!_!`2d#r#s2iQ2iO!SQ~2nO$b~~2sP!U~!_!`2v~2{O!T~~3QO$f~V3XT!]RuS!Q![3Q![!]1f!c!}3Q#R#S3Q#T#o3Q~3mO&l~~3rO&p~~3wOz~~3zTO#S3w#S#T%c#T;'S3w;'S;=`4Z<%lO3w~4^P;=`<%l3w~4fO&r~~4kO&s~",
  tokenizers: [0, 1, 2],
  topRules: {"PromQL":[0,32],"MetricName":[1,162]},
  specialized: [{term: 59, get: (value, stack) => (specializeIdentifier(value) << 1), external: specializeIdentifier},{term: 59, get: (value, stack) => (extendIdentifier(value) << 1) | 1, external: extendIdentifier, extend: true},{term: 59, get: (value) => spec_Identifier[value] || -1}],
  tokenPrec: 0
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf = 167,
  nan = 168,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Atan2 = 7,
  Avg = 8,
  Bottomk = 9,
  Count = 10,
  CountValues = 11,
  Group = 12,
  Max = 13,
  Min = 14,
  Quantile = 15,
  LimitK = 16,
  LimitRatio = 17,
  Stddev = 18,
  Stdvar = 19,
  Sum = 20,
  Topk = 21,
  By = 22,
  Without = 23,
  And = 24,
  Or = 25,
  Unless = 26,
  Start = 27,
  End = 28,
  Smoothed = 29,
  Anchored = 30,
  LineComment = 31,
  PromQL = 32,
  AggregateExpr = 33,
  AggregateOp = 34,
  AggregateModifier = 35,
  GroupingLabels = 36,
  LabelName = 37,
  QuotedLabelName = 38,
  StringLiteral = 39,
  FunctionCallBody = 40,
  BinaryExpr = 41,
  Pow = 42,
  BoolModifier = 43,
  MatchingModifierClause = 44,
  Mul = 45,
  Div = 46,
  Mod = 47,
  Add = 48,
  Sub = 49,
  Eql = 50,
  Gte = 51,
  Gtr = 52,
  Lte = 53,
  Lss = 54,
  Neq = 55,
  FunctionCall = 56,
  FunctionIdentifier = 57,
  AbsentOverTime = 58,
  Identifier = 59,
  Absent = 60,
  Abs = 61,
  Acos = 62,
  Acosh = 63,
  Asin = 64,
  Asinh = 65,
  Atan = 66,
  Atanh = 67,
  AvgOverTime = 68,
  Ceil = 69,
  Changes = 70,
  Clamp = 71,
  ClampMax = 72,
  ClampMin = 73,
  Cos = 74,
  Cosh = 75,
  CountOverTime = 76,
  DaysInMonth = 77,
  DayOfMonth = 78,
  DayOfWeek = 79,
  DayOfYear = 80,
  Deg = 81,
  Delta = 82,
  Deriv = 83,
  Exp = 84,
  FirstOverTime = 85,
  Floor = 86,
  HistogramCount = 87,
  HistogramFraction = 88,
  HistogramQuantile = 89,
  HistogramStdDev = 90,
  HistogramStdVar = 91,
  HistogramSum = 92,
  HistogramAvg = 93,
  DoubleExponentialSmoothing = 94,
  Hour = 95,
  Idelta = 96,
  Increase = 97,
  Info = 98,
  Irate = 99,
  LabelReplace = 100,
  LabelJoin = 101,
  LastOverTime = 102,
  Ln = 103,
  Log10 = 104,
  Log2 = 105,
  MadOverTime = 106,
  MaxOverTime = 107,
  MinOverTime = 108,
  TsOfFirstOverTime = 109,
  TsOfMaxOverTime = 110,
  TsOfMinOverTime = 111,
  TsOfLastOverTime = 112,
  Minute = 113,
  Month = 114,
  Pi = 115,
  PredictLinear = 116,
  PresentOverTime = 117,
  QuantileOverTime = 118,
  Rad = 119,
  Rate = 120,
  Resets = 121,
  Round = 122,
  Scalar = 123,
  Sgn = 124,
  Sin = 125,
  Sinh = 126,
  Sort = 127,
  SortDesc = 128,
  SortByLabel = 129,
  SortByLabelDesc = 130,
  Sqrt = 131,
  StddevOverTime = 132,
  StdvarOverTime = 133,
  SumOverTime = 134,
  Tan = 135,
  Tanh = 136,
  Timestamp = 137,
  Time = 138,
  Vector = 139,
  Year = 140,
  MatrixSelector = 141,
  NumberDurationLiteralInDurationContext = 142,
  NumberDurationLiteral = 143,
  OffsetExpr = 144,
  AnchoredExpr = 145,
  SmoothedExpr = 146,
  ParenExpr = 147,
  SubqueryExpr = 148,
  UnaryExpr = 149,
  UnaryOp = 150,
  VectorSelector = 151,
  LabelMatchers = 152,
  UnquotedLabelMatcher = 153,
  MatchOp = 154,
  EqlSingle = 155,
  EqlRegex = 156,
  NeqRegex = 157,
  QuotedLabelMatcher = 158,
  StepInvariantExpr = 159,
  At = 160,
  AtModifierPreprocessors = 161,
  MetricName = 162;

export { Abs, Absent, AbsentOverTime, Acos, Acosh, Add, AggregateExpr, AggregateModifier, AggregateOp, Anchored, AnchoredExpr, And, Asin, Asinh, At, AtModifierPreprocessors, Atan, Atan2, Atanh, Avg, AvgOverTime, BinaryExpr, Bool, BoolModifier, Bottomk, By, Ceil, Changes, Clamp, ClampMax, ClampMin, Cos, Cosh, Count, CountOverTime, CountValues, DayOfMonth, DayOfWeek, DayOfYear, DaysInMonth, Deg, Delta, Deriv, Div, DoubleExponentialSmoothing, End, Eql, EqlRegex, EqlSingle, Exp, FirstOverTime, Floor, FunctionCall, FunctionCallBody, FunctionIdentifier, Group, GroupLeft, GroupRight, GroupingLabels, Gte, Gtr, HistogramAvg, HistogramCount, HistogramFraction, HistogramQuantile, HistogramStdDev, HistogramStdVar, HistogramSum, Hour, Idelta, Identifier, Ignoring, Increase, Info, Irate, LabelJoin, LabelMatchers, LabelName, LabelReplace, LastOverTime, LimitK, LimitRatio, LineComment, Ln, Log10, Log2, Lss, Lte, MadOverTime, MatchOp, MatchingModifierClause, MatrixSelector, Max, MaxOverTime, MetricName, Min, MinOverTime, Minute, Mod, Month, Mul, Neq, NeqRegex, NumberDurationLiteral, NumberDurationLiteralInDurationContext, Offset, OffsetExpr, On, Or, ParenExpr, Pi, Pow, PredictLinear, PresentOverTime, PromQL, Quantile, QuantileOverTime, QuotedLabelMatcher, QuotedLabelName, Rad, Rate, Resets, Round, Scalar, Sgn, Sin, Sinh, Smoothed, SmoothedExpr, Sort, SortByLabel, SortByLabelDesc, SortDesc, Sqrt, Start, Stddev, StddevOverTime, Stdvar, StdvarOverTime, StepInvariantExpr, StringLiteral, Sub, SubqueryExpr, Sum, SumOverTime, Tan, Tanh, Time, Timestamp, Topk, TsOfFirstOverTime, TsOfLastOverTime, TsOfMaxOverTime, TsOfMinOverTime, UnaryExpr, UnaryOp, Unless, UnquotedLabelMatcher, Vector, VectorSelector, Without, Year, inf, nan, parser };
